import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import shortid from 'shortid';

export default class Switch extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);
    this.state = {
      id: null,
      value: props.value,
    };

    this.changeHandler = this.changeHandler.bind(this);
  }

  componentWillMount() {
    this.setState({ id: shortid.generate() });
  }

  componentWillReceiveProps(newProps) {
    let { value } = this.state;
    const oldValue = this.props.value;
    const newValue = newProps.value;

    if (oldValue !== newValue && value !== newValue) {
      value = newValue;
      this.setState({ value });
    }
  }

  /* Handlers */

  changeHandler(event) {
    const value = event.target.checked;
    const { name, onChange, parent } = this.props;

    this.setState({ value }, () => { onChange(value, name, parent); });
  }

  clickHandler(event) {
    event.stopPropagation();
  }

  /* Render */

  render() {
    const { block, disabled, intl, label } = this.props;
    const { id, value } = this.state;

    if (!id) return null;

    let labelContent = null;
    if (label) {
      const labelClassNames = classNames('switch__label', { 'is-active': value });

      labelContent = (
        <div className="align__cell">
          <span className={labelClassNames}>
            {intl.messages[label] || label}
          </span>
        </div>
      );
    }

    const switchClassNames = classNames('switch', { 'is-disabled': disabled }, { 'switch--block': block });
    return (
      <label htmlFor={id} className={switchClassNames}>
        <div className="align align--fluid align--gutter-xs">
          <div className="align__cell align__cell--shrink">
            <input
              checked={value}
              className="switch__checkbox"
              disabled={disabled}
              id={id}
              type="checkbox"
              onClick={this.clickHandler}
              onChange={this.changeHandler}
            />
          </div>
          {labelContent}
        </div>
      </label>
    );
  }
}

Switch.propTypes = {
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  parent: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]),
};



// WEBPACK FOOTER //
// ./js/components/switch/index.jsx